import React from 'react';
import { Box, Icon, useFirebaseContext } from '@medely/ui-kit';

const ApplicationHeaderLogout = (): React.ReactElement => {
  const { logout } = useFirebaseContext();

  return (
    <Box onClick={() => logout?.()} aria-label="Log out" testId="application-logout" pl={2}>
      <Icon name="right-from-bracket" iconSize="20px" variant="custom" color="text.secondary" />
    </Box>
  );
};

export default ApplicationHeaderLogout;
